import { MaskedLines, FadeUp } from "./Reveal";

export const PageHeader = ({ overline, titleLines, lede, dark = false }) => (
  <div className={`pt-40 md:pt-52 pb-16 md:pb-24 ${dark ? "bg-ink text-paper" : "bg-paper text-ink"}`}>
    <div className="max-w-6xl mx-auto px-6 md:px-12">
      <FadeUp y={12}>
        <p className="text-[13px] md:text-[14px] font-semibold uppercase tracking-[0.16em] leading-[1.2] text-terra">{overline}</p>
      </FadeUp>
      <MaskedLines
        lines={titleLines}
        delay={0.15}
        className="mt-6 max-w-4xl font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.04]"
      />
      {lede && (
        <FadeUp delay={0.5} className="mt-8">
          <p className={`max-w-2xl text-base md:text-lg leading-relaxed ${dark ? "text-paper/60" : "text-mute"}`}>{lede}</p>
        </FadeUp>
      )}
    </div>
  </div>
);
